import { Box, Button, CircularProgress, Text, Image } from "@chakra-ui/react";
import { useEffect, useState } from "react";

export default function CoursePerformanceReport({ participants, loading }) {
    const [loadMoreVisible, setLoadMoreVisible] = useState(true)
    const [visibleData, setVisibleData] = useState([])

    useEffect(() => {
        if(participants.length > 10){
            setVisibleData(participants.slice(0,10))
        }
        else{
            setVisibleData(participants)
            setLoadMoreVisible(false)
        }
    }, [participants])

    const loadMoreHandler = () => {
        if(visibleData.length + 10 < participants.length){
            setVisibleData(participants.slice(0, visibleData.length+10))
        }
        else{
            setVisibleData(participants)
            setLoadMoreVisible(false)
        }
    }

    return (
        <>
            {
                loading ? <Box width='100%' d='flex' justifyContent='center' alignItems='center' my='0.5rem'>
                    <CircularProgress isIndeterminate color='#3e59de' size='50px' />
                </Box> :
                    <>
                        <Box
                            w='100%'
                            d='flex'
                            justifyContent='space-between'
                            alignItems='center'
                            mb='1rem'
                            px='1rem'
                        >
                            <Text variant='custom' style={{ fontFamily: 'Mulish, sans-serif' }} width='20%'>PARTICIPANT</Text>
                            <Text variant='custom' style={{ fontFamily: 'Mulish, sans-serif' }} width='17.5%' textAlign='center'>DAYS ACTIVE</Text>
                            <Text variant='custom' style={{ fontFamily: 'Mulish, sans-serif' }} width='15%' textAlign='center'>TODAYS PROGRESS (IN MINUTES)</Text>
                            <Text variant='custom' style={{ fontFamily: 'Mulish, sans-serif' }} width='20%' textAlign='center'>COURSE PROGRESS</Text>
                            <Text variant='custom' style={{ fontFamily: 'Mulish, sans-serif' }} width='15%' textAlign='center'>POINTS EARNED</Text>
                            <Text variant='custom' style={{ fontFamily: 'Mulish, sans-serif' }} width='15%' textAlign='center'>CERTIFICATES</Text>
                        </Box>
                        <Box
                            w='100%'
                            border='1px solid rgba(0, 0, 0, 0.1)'
                            boxShadow='0px 4px 10px rgba(0, 0, 0, 0.1)'
                            borderRadius='10px'
                            px='1rem'
                            mb='2rem'
                            bg="#ffffff"
                        >
                            {
                                visibleData.map((user, idx) => <Box
                                    w='100%'
                                    d='flex'
                                    justifyContent='space-between'
                                    alignItems='center'
                                    py='1rem'
                                    fontSize='15px'
                                    color='#000000'
                                    fontWeight='600'
                                    style={{ fontFamily: 'Mulish, sans-serif' }}
                                    borderBottom='1px solid rgba(0, 0, 0, 0.05)'
                                    key={idx}
                                >
                                    <Text width='20%' textTransform='capitalize'>{`${user.first_name} ${user.last_name}`}</Text>
                                    <Text width='17.5%' textAlign='center'>{user.completed_sessions ? user.completed_sessions : 'N/A'}</Text>
                                    <Text width='15%' textAlign='center'>{user.quiz_completed ? user.quiz_completed : 'N/A'}</Text>
                                    <Text width='20%' textAlign='center'>{user.live_class_attended ? user.live_class_attended : 'N/A'}</Text>
                                    <Text width='15%' textAlign='center'>{user.points_earned ? user.points_earned : 'N/A'}</Text>
                                    <Box width = '15%' display='flex' justifyContent = 'center'><Image src = {user.certificates ? '/images/green-tick.svg' : '/images/Red-X.svg'} alt = 'certificates' width = '20px' height = '20px' /></Box>
                                </Box>
                                )
                            }
                            {
                                loadMoreVisible &&
                                <Button
                                    color='#00000099'
                                    style={{ fontFamily: 'Mulish, sans-serif' }}
                                    fontWeight='700'
                                    fontSize={['14px', '16px', '18px', '20px']}
                                    border='2px solid rgba(0, 0, 0, 0.1)'
                                    boxShadow='0px 3px 16px rgba(0, 0, 0, 0.1)'
                                    borderRadius='xl'
                                    py={['0.5rem', '0.75rem', '1rem', '1.5rem']}
                                    px={['0.75rem', '1rem', '1.5rem', '2rem']}
                                    m='2rem'
                                    bg='#ffffff'
                                    onClick={loadMoreHandler}
                                >
                                    Load More...
                                </Button>
                            }
                        </Box>
                    </>
            }
        </>
    )
}